import { useGetVaCommissionsQuery } from "../app/vaApi/vaApi";

export function useVaCommissions() {
  const { data, isLoading, isError } = useGetVaCommissionsQuery();

  return {
    commissions: data?.data ?? [],
    isLoading,
    isError,
  };
}
